import React, { FC } from 'react'

//* utils
import { LocaleCodes } from '../../../constants/localization.constants'
import { ComponentAnnouncement } from '../../../models/components/announcement'
import { ComponentMainNavBanner } from '../../../models/components/mainNavBanner'
import { MenuGroup } from '../../../models/others/menuGroup'
import { findTarget } from '../../../utils/microcopy.utils'

//* components
import Layout from '../../layouts/layout'
import { Modules } from './modules'

type Props = {
  path: string
  pageContext: any
  location?: any
  headerData?:
    | {
        allContentfulNavMenu: {
          nodes: MenuGroup[]
        }
      }
    | undefined
  footerData?:
    | {
        allContentfulNavMenu: {
          nodes: MenuGroup[]
        }
      }
    | undefined
  announcementData?: ComponentAnnouncement
  mainNavBannerData?: ComponentMainNavBanner
  browserLanguageData?: any
}

const ThankYouPage: FC<Props> = ({
  path,
  pageContext,
  location,
  headerData,
  footerData,
  announcementData,
  mainNavBannerData,
  browserLanguageData,
}) => {
  if (!pageContext.thankYouPageData) return null
  const { title, subtitle, number, genericIntro, referrer, downloadPdf, slug } =
    pageContext.thankYouPageData

  const defaultLocale = pageContext.pageLocale || LocaleCodes.ENGLISH.code
  const generics = genericIntro?.values || []
  const downloadAssetExists = referrer?.downloadAsset?.id || downloadPdf?.id
  const resourceNumber = number || 8
  const thankYouPageHero = {
    headline: title || findTarget(`resource.${resourceNumber}.ThankYouTITLE.text`, generics),
    subheadline: {
      subheadline:
        subtitle ||
        findTarget(
          downloadAssetExists
            ? `resource.${resourceNumber}.ThankYouDOWNLOAD.text`
            : `resource.${resourceNumber}.ThankYouSUBTITLE.text`,
          generics
        ),
    },
    cta: downloadPdf ? [downloadPdf] : [],
    useCase: 'Centered text with dots',
    heroTheme: 'light',
  }

  return (
    <Layout.Template
      lang={defaultLocale}
      headerData={headerData}
      footerData={footerData}
      announcementData={announcementData}
      mainNavBannerData={mainNavBannerData}
      browserLanguageData={browserLanguageData}
      pageType="thankYou"
      slug={slug || ''}
      availableLocales={pageContext.availableLocales}>
      <Modules
        data={pageContext.thankYouPageData}
        thankYouPageHero={thankYouPageHero}
        thankYouFeaturedResource={pageContext.thankYouFeaturedResource}
        locale={defaultLocale}
        relatedResources={pageContext.relatedResources}
        availableLocales={pageContext.availableLocales}
        path={path}
        location={location}
      />
    </Layout.Template>
  )
}

export default ThankYouPage
